import React from "react";
import { CalendarDays, ChevronLeft, ChevronRight, ListFilter, Plus, RefreshCw } from "lucide-react";

const viewOptions = [
    { value: "dayGridMonth", label: "Mois" },
    { value: "timeGridWeek", label: "Semaine" },
    { value: "timeGridDay", label: "Jour" },
    { value: "listWeek", label: "Agenda" },
];

export default function CalendarToolbar({
    title,
    currentView,
    onViewChange,
    onToday,
    onPrev,
    onNext,
    onRefresh,
    onCreate,
    canCreate,
}) {
    return (
        <div className="calendar-toolbar">
            <div className="calendar-toolbar__intro">
                <div className="calendar-toolbar__eyebrow">
                    <CalendarDays size={14} />
                    <span>Agenda</span>
                </div>
                <h1 style={{ fontSize: '1.3rem' }}>{title}</h1>
            </div>

            <div className="calendar-toolbar__actions">
                <div className="calendar-toolbar__nav">
                    <button type="button" className="calendar-btn calendar-btn--ghost" onClick={onPrev}>
                        <ChevronLeft size={14} />
                    </button>
                    <button type="button" className="calendar-btn calendar-btn--ghost" onClick={onToday}>
                        Aujourd'hui
                    </button>
                    <button type="button" className="calendar-btn calendar-btn--ghost" onClick={onNext}>
                        <ChevronRight size={14} />
                    </button>
                </div>

                <div className="calendar-toolbar__selectors">
                    {/*<label className="calendar-select">*/}
                    {/*    <ListFilter size={13} />*/}
                    {/*    <select value={currentView} onChange={(event) => onViewChange(event.target.value)}>*/}
                    {/*        {viewOptions.map((option) => (*/}
                    {/*            <option key={option.value} value={option.value}>*/}
                    {/*                {option.label}*/}
                    {/*            </option>*/}
                    {/*        ))}*/}
                    {/*    </select>*/}
                    {/*</label>*/}

                    <button type="button" className="calendar-btn calendar-btn--ghost" onClick={onRefresh}>
                        <RefreshCw size={13} />
                        <span>Rafraichir</span>
                    </button>

                    {canCreate && (
                        <button type="button" className="calendar-btn calendar-btn--primary" onClick={onCreate}>
                            <Plus size={14} />
                            <span>Nouveau événement</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
